<template>
  <b-modal id="wazzup-iframe-modal"
           :title="`Wazzup`"
           size="xl"
           hide-footer
           centered>
    <iframe class="wazzup-iframe" :src="wazzupIframeUrl" allow="microphone *" ></iframe>
  </b-modal>
</template>

<script setup>
import { computed } from "vue"
import { useStore } from "vuex"

const store = useStore()

const wazzupIframeUrl = computed(() => store.state.crm.wazzupIframeUrl)
</script>

<style scoped lang="scss">
.wazzup-iframe {
  width: 100%;
  border: 1px solid #eee;
  height: calc(100vh - 200px);
}
</style>
